import React from "react";
import { makeAutoObservable, configure } from "mobx";
import { db } from "../services/firebase";
import { filter, reverse, sortBy } from "ramda";

configure({
  enforceActions: "never",
});

export class QuestionStore {
  questions = [];
  countQuestion = 0;
  currentQuestion = {};

  constructor() {
    makeAutoObservable(this);
  }

  setFavoriteQuestions = () => {
    db.ref("question-list")
      .orderByChild("ratio")
      .once("value", (snapshot) => {
        let questions = [];
        snapshot.forEach((snap) => {
          questions.push({ id: snap.key, ...snap.val() });
        });
        this.countQuestion = 0;
        this.questions = filter((question) => question.approved === 1, reverse(questions));
      });
  };

  setNewestQuestions = () => {
    db.ref("question-list")
      .orderByChild("timeStamp")
      .once("value", (snapshot) => {
        let questions = [];
        snapshot.forEach((snap) => {
          questions.push({ id: snap.key, ...snap.val() });
        });
        this.countQuestion = 0;
        this.questions = filter((question) => question.approved === 1, reverse(questions));
      });
  };

  setShuffledQuestions = () => {
    db.ref("question-list").once("value", (snapshot) => {
      let questions = [];
      snapshot.forEach((snap) => {
        questions.push({ id: snap.key, ...snap.val() });
      });
      this.countQuestion = 0;
      this.questions = filter(
        (question) => question.approved === 1,
        sortBy(() => Math.random() - 0.5, questions)
      );
    });
  };

  onClickUpdateLikes = () => {
    const currentQuestion = this.questions[this.countQuestion];
    db.ref("question-list")
      .child(currentQuestion.id)
      .update({
        nLikes: currentQuestion.nLikes + 1,
        ratio: currentQuestion.nLikes + 1 + currentQuestion.nDislikes,
      })
      .then(() => {
        this.countQuestion === this.questions.length - 1
          ? (this.countQuestion = 0)
          : (this.countQuestion = this.countQuestion + 1);
      });
  };

  onClickUpdateDislikes = () => {
    const currentQuestion = this.questions[this.countQuestion];
    db.ref("question-list")
      .child(currentQuestion.id)
      .update({
        nDislikes: currentQuestion.nDislikes - 1,
        ratio: currentQuestion.nLikes + (currentQuestion.nDislikes - 1),
      })
      .then(() => {
        this.countQuestion === this.questions.length - 1
          ? (this.countQuestion = 0)
          : (this.countQuestion = this.countQuestion + 1);
      });
  };
}

const questionStoreContext = React.createContext(new QuestionStore());

export const useQuestionStore = () => React.useContext(questionStoreContext);
